import { Services } from "components/Constants";
import React from "react";
import styled from "styled-components/macro";
import ServiceItem from "./ServiceItem";

const ServicesBar = () => {
  return (
    <ServicesBarContainer>
      {Services.map((service, idx) => {
        return <ServiceItem key={idx} text={service.text} icon={service.icon} />;
      })}
    </ServicesBarContainer>
  );
};

const ServicesBarContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: flex-start;
  margin: 20px 10px;
`;

export default ServicesBar;
